import { ApiState } from "infrastructure/api";
import { resourceSliceFactory } from "infrastructure/store/state";
import type { TransactionsState } from "./types";

const state: TransactionsState = resourceSliceFactory({
    transactionDetailsLoadingState: ApiState.Idle
});

export const sliceToken = 'transactions';

export default state;
